import { AuthService } from './authService';
import { AdminPagedResponse, AdminInspectionSummaryDto } from '../types/adminDataInspection';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

interface PagedQueryParams {
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortDirection?: string;
  filters?: Record<string, string>;
}

class AdminDataInspectionService {

  /**
   * Get summary row counts for all tables
   */
  async getSummary(): Promise<AdminInspectionSummaryDto> {
    const response = await AuthService.authenticatedGet(
      `${API_BASE_URL}/admin-data-inspection/summary`
    );

    if (!response.ok) {
      throw new Error(`Failed to get summary: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  }

  /**
   * Generic paged table fetch — works for any table endpoint
   */
  async getPagedTable<T>(endpoint: string, params: PagedQueryParams): Promise<AdminPagedResponse<T>> {
    const searchParams = new URLSearchParams();
    searchParams.set('pageNumber', params.pageNumber.toString());
    searchParams.set('pageSize', params.pageSize.toString());

    if (params.sortColumn) {
      searchParams.set('sortColumn', params.sortColumn);
    }
    if (params.sortDirection) {
      searchParams.set('sortDirection', params.sortDirection);
    }

    // Add filters with "filter." prefix
    if (params.filters) {
      for (const [key, value] of Object.entries(params.filters)) {
        if (value) {
          searchParams.set(`filter.${key}`, value);
        }
      }
    }

    const url = `${API_BASE_URL}/admin-data-inspection/${endpoint}?${searchParams.toString()}`;
    const response = await AuthService.authenticatedGet(url);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to get ${endpoint}: ${response.status} ${response.statusText}. ${errorText}`);
    }

    return await response.json();
  }
}

export const adminDataInspectionService = new AdminDataInspectionService();
